<div class="wrapper {{ this.class }}">
  <div class="icon-wrapper">
    <itl-alberta-icon class="{{ this.class }}" [name]="this.icon"></itl-alberta-icon>
  </div>
  <div class="information-text">
    <ng-content></ng-content>
  </div>
</div>
